var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('v-row',{attrs:{"dense":""}},[_c('v-col',{attrs:{"cols":"6"}},[_c('FiltrosLeads',{attrs:{"loading":_vm.loading},on:{"filtrosModificados":_vm.realizarBusqueda}})],1),_c('v-col',{attrs:{"cols":"6"}},[_c('LeadsAgenda')],1),_c('v-col',{attrs:{"cols":"12"}},[_c('ResultadosLeads',{attrs:{"loading":_vm.loading,"leads":_vm.leads}})],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }